import {
  targetTypeToIconImg,
  targetTypeToSubTitle,
} from 'components/features/target-achievement-support/utils/targetInfo';
import { TargetType } from 'components/features/target-achievement-support/utils/type';
import React from 'react';

type Props = {
  targetType: TargetType;
};

export const TargetItemIcon = ({ targetType }: Props): React.ReactElement => {
  return (
    <>
      <div
        className={`rounded-full overflow-hidden grid items-center justify-center`}
        style={{ aspectRatio: '1' }}>
        <img
          className={`w-full h-full`}
          style={{
            gridColumn: 1,
            gridRow: 1,
            objectFit: 'cover',
            aspectRatio: '1',
          }}
          src={targetTypeToIconImg(targetType)}
          alt="目標アイコン"
        />
        <div
          className={`z-10 bg-black opacity-30 w-full h-full`}
          style={{ gridColumn: 1, gridRow: 1 }}></div>
        <div
          className={`grid items-center justify-center`}
          style={{ gridColumn: 1, gridRow: 1 }}>
          <div className={`z-20 text-white text-1.5xs `}>
            {targetTypeToSubTitle(targetType)}
          </div>
        </div>
      </div>
    </>
  );
};
